<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';

export default {
  name: 'CpChatButton',
  components: {
    CpButton: require('../button').default,
    CpTooltip: require('../tooltip').default,
    CpTooltipToggle: require('../tooltip-toggle').default,
  },
  directives: {
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    callback: { type: Function },
    otherUserId: { type: [String, Number], default: null },
    thin: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    text: { type: String },
    noborder: { type: Boolean, default: true },
    secondary: { type: Boolean, default: false },
    primaryGradient: { type: Boolean, default: false },
    marginLeft: { type: String, default: '1' },
  },
  async mounted() {
    await this.handleChatEnabled(this.otherUserId);
  },
  computed: {
    isChatEnabledComp() {
      return this.chatEnabledStatus[this.otherUserId] || false;
    },
    tooltipId() {
      return this.otherUserId + 'actionTooltipId';
    },
    ...mapState(useUserStore, ['chatEnabledStatus']),
  },
  methods: {
    ...mapActions(useUserStore, ['handleChatEnabled']),
  },
};
</script>
<template>
  <span v-margin-left="marginLeft">
    <CpTooltipToggle :for="tooltipId" hoverable>
      <CpButton :noborder="noborder" :secondary="secondary" :primary-gradient="primaryGradient" @click="callback" :disabled="!isChatEnabledComp || disabled" :loading="loading" :block="block" :thin="thin">
        <span v-if="text">{{ text }}</span>
        <i v-else class="fal fa-comment-alt-lines primary-color fa-1-5x"></i>
      </CpButton>
    </CpTooltipToggle>
    <CpTooltip v-if="!isChatEnabledComp" light unstyled :id="tooltipId">
      <span class="tooltipOption body1 neutral6-color"
        ><i class="fal fa-info-circle tooltipIcon"></i>In order to Direct Message this user, you need to Follow each other</span
      >
    </CpTooltip>
  </span>
</template>

<style scoped>
.chatButtonContainer {
  display: flex;
  align-items: center;
  width: 50%;
}
.tooltipOption {
  display: flex;
  align-items: center;
  padding: 8px;
}
.tooltipIcon {
  margin-right: 10px;
}
</style>
